import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import api from '../api/client';

const TYPE_LABELS = {
  admin_grant: { label: 'Admin feltöltés', color: 'text-green-400' },
  admin_deduct: { label: 'Admin levonás', color: 'text-red-400' },
  deposit: { label: 'Befizetés', color: 'text-green-400' },
  withdraw: { label: 'Kifizetés', color: 'text-red-400' },
  win: { label: 'Nyeremény', color: 'text-yellow-400' },
  loss: { label: 'Veszteség', color: 'text-red-400' },
};

export default function Profile() {
  const { user } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/wallet/transactions').then((res) => {
      setTransactions(res.data);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold mb-6">Profilom</h1>

        <div className="card mb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-yellow-500/20 flex items-center justify-center text-2xl font-bold text-yellow-400">
              {user?.username?.[0]?.toUpperCase()}
            </div>
            <div>
              <p className="font-semibold text-lg">{user?.username}</p>
              <span className={user?.role === 'admin' ? 'badge-admin' : 'badge-user'}>
                {user?.role === 'admin' ? 'Admin' : 'Játékos'}
              </span>
            </div>
            <div className="ml-auto text-right">
              <p className="text-slate-400 text-sm">Egyenleg</p>
              <p className="text-yellow-400 font-bold text-xl">{Number(user?.balance ?? 0).toLocaleString('hu')} 💰</p>
            </div>
          </div>
        </div>

        <h2 className="text-lg font-semibold mb-4">Tranzakciók</h2>
        <div className="card p-0 overflow-hidden">
          {loading ? (
            <p className="text-slate-400 text-sm p-6">Betöltés...</p>
          ) : transactions.length === 0 ? (
            <p className="text-slate-400 text-sm p-6">Még nincs tranzakció.</p>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-700 text-slate-400">
                  <th className="text-left px-4 py-3">Típus</th>
                  <th className="text-left px-4 py-3">Összeg</th>
                  <th className="text-left px-4 py-3 hidden sm:table-cell">Megjegyzés</th>
                  <th className="text-left px-4 py-3">Dátum</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx) => {
                  const meta = TYPE_LABELS[tx.type] || { label: tx.type, color: 'text-slate-300' };
                  return (
                    <tr key={tx.id} className="border-b border-slate-700/50 hover:bg-slate-700/30">
                      <td className={`px-4 py-3 font-medium ${meta.color}`}>{meta.label}</td>
                      <td className={`px-4 py-3 font-semibold ${parseFloat(tx.amount) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                        {parseFloat(tx.amount) >= 0 ? '+' : ''}{Number(tx.amount).toLocaleString('hu')} 💰
                      </td>
                      <td className="px-4 py-3 text-slate-400 hidden sm:table-cell">{tx.note || '—'}</td>
                      <td className="px-4 py-3 text-slate-500">
                        {new Date(tx.created_at).toLocaleDateString('hu', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}
